export const buildErrorMessages = (errors: Record<string, string>): string => {
  const errorsList = Object.entries(errors).reduce<Record<string, string[]>>(
    (acc, [key, message]) => {
      if (message !== undefined) {
        acc[key] = [message]
      }
      return acc
    },
    {}
  )

  const flatErrorListMessages = Object.values(errorsList).flat().join(', ')
  return flatErrorListMessages
}
